import type { ReservedStaffTimeRequest, ReservedStaffTimeResponse } from '../api/generated';
import { RESERVED_STAFF_TIME_TYPE } from '../components/ReservedStaffTimeBookings/reservedStaffTimeBookingConstants';
import { useBookings } from './useBookings';
import type { UseBookingsResult } from './useBookings';

export type UseReservedStaffTimeBookingsResult = UseBookingsResult<
  ReservedStaffTimeRequest,
  ReservedStaffTimeResponse
>;

export function useReservedStaffTimeBookings(
  locationId: string | null
): UseReservedStaffTimeBookingsResult {
  return useBookings<ReservedStaffTimeRequest, ReservedStaffTimeResponse>(
    RESERVED_STAFF_TIME_TYPE,
    locationId
  );
}
